import {
  createEmptyBankAccount,
  useBankAccountsActions,
} from "@/api/bank-accounts"
import { Button } from "@/components/ui/button"
import { SheetClose, SheetFooter } from "@/components/ui/sheet"
import { AsyncButton } from "@/components/ux/async.button"
import { DetailsSheet } from "@/components/ux/details.sheet"
import BankAccountForm from "./bank-account.form"
import { useForm } from "react-hook-form"
import { zodResolver } from "@hookform/resolvers/zod"
import { bankAccountFormSchema } from "./bank-account.schema"
import { z } from "zod"
import { Form } from "@/components/ui/form"

interface BankAccountSheetProps {
  onClose: (open: boolean) => void;
}

export default function BankAccountSheet({ onClose }: BankAccountSheetProps) {
  const { create } = useBankAccountsActions()
  const form = useForm<z.infer<typeof bankAccountFormSchema>>({
    resolver: zodResolver(bankAccountFormSchema),
    defaultValues: createEmptyBankAccount(),
  })

  const onSubmit = async (data: z.infer<typeof bankAccountFormSchema>) => {
    await create(data)
    onClose(false)
  }

  return (
    <DetailsSheet title="Bank Account Details" onClose={onClose}>
      <Form {...form}>
        <BankAccountForm />
        <SheetFooter>
          <SheetClose asChild>
            <Button variant="outline" type="button">
              Cancel
            </Button>
          </SheetClose>
          <AsyncButton type="submit" onClick={form.handleSubmit(onSubmit)}>
            Add Bank Account
          </AsyncButton>
        </SheetFooter>
      </Form>
    </DetailsSheet>
  )
}
